<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button block variant="info" @click="doPrint">
          <i class="fa fa-print" aria-hidden="true"></i> In
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal">
      <div id="print">
        <b-row>
          <template v-for="(item, n) in listItems">
            <div  v-if="item.type == 'BAG'" :key="n">
              <TemBichPreview
                :code="tem.code"
                :Tem="tem"
                :temInfo="item"
                :manufacture="manufacture"
                style="width:300px"
              ></TemBichPreview>
            </div>
            <div  v-else-if="item.type == 'SACK'" :key="'sack_'+n">
              <TemBaoPreview
                class="break-auto"
                :code="tem.code"
                :Tem="tem"
                :temDetail="item"
                :manufacture="manufacture"
                style="width:350px; margin:3px; display: inline-block;float:left"
              ></TemBaoPreview>
            </div>
            <TemDH
              :key="'hd_'+n"
              class="break-auto"
              :code="tem.code"
              v-else-if="item.type == 'ORDER'"
              :Tem="tem"
              :info="item"
              :manufacture="manufacture"
              style="width:350px; margin:3px;  display: inline-block;float:left"
            ></TemDH>
          </template>
        </b-row>
      </div>
    </block>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
import { userService, temService } from "@/_services";

import TemBichPreview from "./__TemBichPreview";
import TemBaoPreview from "./__TemBaoPreview";
import TemDH from "./__TemDH";

export default {
  props: {},
  components: {
    TemBichPreview,
    TemBaoPreview,
    TemDH
  },
  data() {
    return {
      visible: false,
      manufacture: {},
      tem: {},
      quantity: 1,
      type: "bao",
      listItems: []
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.refs.csInfo.validate().then(success => {
        if (!success) return;
        this.refs.bmdal.block();
        if (self.info.id) {
          userService
            .update(self.info.id, self.info)
            .then(res => {
              self.ownInfo.name = self.info.name;
              if (type == 0) {
                self.visible = false;
              }
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              this.refs.bmdal.unBlock();
            });
        } else {
          userService
            .create(self.info)
            .then(res => {
              self.emit("submit:success");
              if (type == 0) {
                self.visible = false;
              }
              self.info = { username: "", email: "" };
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              this.refs.bmdal.unBlock();
            });
        }
      });
    },
    setData(manufacture, tem, type, listItem) {
      this.tem = tem;
      this.listItems = listItem;
      this.manufacture = manufacture;
      this.type = type;
      if (type == "bich") {
        this.quantity = tem.quantity;
      } else if (type == "bao") {
        this.quantity = tem.quantityBag;
      } else {
        this.quantity = tem.quantityCore;
      }
    },
    doPrint() {
      // let listTemDetails = [];
      // this.listItems.forEach(element => {
      //   let newItem = Object.assign({}, element);
      //   delete newItem._showDetails;
      //   listTemDetails.push(newItem);
      // });
      temService
        .print(this.listItems)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.listItems = res.data;
        })
        .finally(() => {
          this.$refs.bTem.unBlock();
        });
      this.$print("print");
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss"></style>
